module.exports = __webpack_public_path__ + "static/media/sb_tip3.f986ada4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/sb_tip3.jpg
// module id = 544
// module chunks = 0